(function($) {
	formHelper.addRule({
		form: '.form-manage-gml',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			}
		}
	});
})(jQuery);



jQuery(function initResortMarketingLabelEdit($) {
	$('.edit-resort-marketing-label-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-gml');
		var $submitBtn             = $container.find('.btn-submit');
		var $deleteBtn             = $container.find('.delete-button');

		$submitBtn.click(function() {
			$('#delete-gml').val('no');
			$form.submit();
		});

		$deleteBtn.click(function() {
			var r = confirm("Did you want to Continue to Delete this ResortID?");
			if (r === true) {
				$('#delete-gml').val('yes');
				$form.submit();
			}
		});
	});
});


jQuery(function initResortMarketingLabelAdd($) {
	$('.add-resort-marketing-label-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-add-gml');
		

		//alert("mlid-value" + $('#passed-mlid').val());
		

		if($('#passed-mlid').val() !== '') {
			$("#mlid option:last").attr("selected", "selected");
			$("#srcode option:last").attr("selected", "selected");
			$("#destid option:last").attr("selected", "selected");
			$('#resortid').focus();
		}
	});
});
